import { render, staticRenderFns } from "./CreateReasonModal.vue?vue&type=template&id=44e5662e&scoped=true&"
import script from "./CreateReasonModal.vue?vue&type=script&lang=js&"
export * from "./CreateReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5662e",
  null
  
)

export default component.exports